import React from 'react';

import ConlicitacaoUpsellCard from 'components/atoms/conlicitacao_upsell_card';
import useOnlyConlicitaseg from 'hooks/useOnlyConlicitaseg';
import { Container, PolicyResultVariant } from './styles';

interface PolicyResultProps {
  variant: PolicyResultVariant;
  icon: React.ReactNode;
  title: string;
  source: string;
  children: React.ReactNode;
}

const PolicyResult: React.FC<PolicyResultProps> = ({ variant, icon, title, source, children }) => {
  const isOnlyConlicitaseg = useOnlyConlicitaseg();

  const handleBack = () => {
    window.location.href = '/conlicitaseg';
  };

  return (
    <Container variant={variant} className="page-container">
      <div className="container-fluid big-resolutions py-5 px-md-5">
        <div className="row justify-content-center mt-5">
          <div className="col-12 mx-auto">
            <button type="button" className="back-link btn btn-link px-0 mb-2" onClick={handleBack}>
              <i className="material-icons" aria-hidden="true">
                keyboard_arrow_left
              </i>
              Voltar para lista de cotações e apólices
            </button>

            <div className="result-card">
              <div className="result-icon" aria-hidden="true">
                {icon}
              </div>
              <div className="result-content">
                <h1 className="result-title">{title}</h1>
                <p className="result-text">{children}</p>
              </div>
            </div>

            {isOnlyConlicitaseg && <ConlicitacaoUpsellCard source={source} />}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default PolicyResult;
